export default {
	en: {
		translation: {
			dropbox: {
				no_auth_title: "Upload files from your Dropbox account.",
				no_auth_action: "Connect to Dropbox",
				no_photos: "No Photos",
				no_files: "No Files",

				root_crumb: "Root",

				list_headers: {
					select: "Select",
					name: "Name",
					modified: "Modified",
				},

				menu: {
					browse: "Browse",
					recent: "Recent",
				},

				authenticating: "Authenticating...",
			},
		},
	},
};
